export enum SEARCH_TYPE {
  EMAIL = 'email',
  SUBJECT = 'subject',
  COUPON = 'coupon'
}
